export default {
      id: "ic_play-v2-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_play-v2-usage",
      toString: function () {
        return this.url;
      }
    }